import { validateHeapSafely } from '@/metrics/heap.types';
import { useFlags } from '@flagsmith/flagsmith/react';
import { useEffect } from 'react';
import { FLAGSMITH_KEYS } from './key';

type FlagType = (typeof FLAGSMITH_KEYS)[keyof typeof FLAGSMITH_KEYS];

export const useGetFlagValue = (reqFlag: FlagType) => {
  const flag = useFlags([reqFlag]);

  const f = flag[reqFlag];
  const ready = f !== undefined;
  const isEnabled = f?.enabled ?? false;
  const value = f?.value ?? null;

  useEffect(() => {
    if (!ready) return;
    if (!validateHeapSafely()) return;

    window.heap.addUserProperties({
      [`flag_${reqFlag}`]: isEnabled ? String(value) : 'disabled',
    });

    const dedupKey = `flag_exposed_${reqFlag}`;

    if (sessionStorage.getItem(dedupKey)) return;
    sessionStorage.setItem(dedupKey, '1');

    window.heap.track('flag-exposure', {
      flagKey: reqFlag,
      enabled: isEnabled,
      value,
    });
  }, [ready, isEnabled, value, reqFlag]);

  return {
    enable: isEnabled,
    value: value,
    ready,
  };
};
